import { addWeeks, isAfter } from 'date-fns';

import { getEconomicEventsApi } from '@flipster/apis/v1/market';
import { convertDate, formatDatetime, getTimezoneOffset } from '@flipster/utils/datetime';

import { TimescaleMark } from '../../lib/charting_library';
import { ChartStyles, TvVisibleEventIndicatorStorageKey } from '../misc/constants';
import Sparkles from './sparkles-icon.png';

export const drawEconomicEventMarks = async () => {
  try {
    const enabledEvent = localStorage.getItem(TvVisibleEventIndicatorStorageKey) !== 'false';
    if (!enabledEvent) return [];

    const {
      data: { events },
    } = await getEconomicEventsApi();

    const timeScaleMarks: TimescaleMark[] = [];

    events.forEach((event) => {
      const time = convertDate(event.timestamp);
      if (!time || isAfter(time, addWeeks(new Date(), 1))) return;
      timeScaleMarks.push({
        id: event.title,
        time: Math.floor((time.getTime() || 0) / 1000),
        color: ChartStyles.Color.Marker.TimeScaleMarker,
        label: event.title,
        tooltip: [event.title, event.content, `${formatDatetime(time)} ${getTimezoneOffset()}`],
        imageUrl: Sparkles.src, // Flipster Design System을 추가하기 보다 이미지 하나만 추가함
        showLabelWhenImageLoaded: false,
      });
    });

    return timeScaleMarks;
  } catch {
    return [];
  }
};
